module.exports = __webpack_public_path__ + "image/CN_News3_CN_Photo.1782790484418.jpg";